import { FC, ReactElement, useEffect, useId } from 'react';

import { Loader } from '@pp/core/src/components/loader/index';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { GameStatus } from '@pp/core/src/store/slices/game/types';

import { getDateTime } from '../../../../config/utils';
import { useTableTopDataFetcher } from '../../../../store/apiHooks/useTableTopDataFetcher';
import { useGameDispatch } from '../../../../store/GameStore';
import { useHighflyerGameStateSlice } from '../../../../store/slices/highflyerGame/selectors';
import { highflyerGameStateActions } from '../../../../store/slices/highflyerGame/slice';
import { SingleMultiplier } from '../../../tableSheet/singleMultiplier/SingleMultiplier';
import { ErrorMessage } from '../../errorMessage/ErrorMessage';
import { ScrollableWrapper } from '../../scrollableWrapper/ScrollableWrapper';
import { openHashModel } from '../../tableHistory/openHashModal';
import { TableTopInfo, TableTopTab } from '../type';

import styles from './TableTopResults.module.css';

export const TableTopResults: FC = () => {
  const id = useId();
  const dispatch = useGameDispatch();
  const tableTopDataFetcher = useTableTopDataFetcher();
  const isApiRejected = useHighflyerGameStateSlice.getIsApiRejected();
  const currentPeriod = useHighflyerGameStateSlice.currentCalenderOption();
  const tableTopData = useHighflyerGameStateSlice.tableTopData()?.multipliers;
  const isTimerStarted = useGameStateSlice.getCurrentStatus() === GameStatus.PlaceYourBets;

  useEffect(() => {
    dispatch(highflyerGameStateActions.setErrorOccured());
    dispatch(highflyerGameStateActions.setCurrentTopTab(TableTopTab.RESULTS));
  }, [dispatch]);

  useEffect(() => {
    dispatch(highflyerGameStateActions.setErrorOccured());
    tableTopDataFetcher(TableTopTab.RESULTS, true);
  }, [currentPeriod, dispatch, tableTopDataFetcher]);

  useEffect(() => {
    if (!isApiRejected && isTimerStarted) {
      tableTopDataFetcher(TableTopTab.RESULTS, isTimerStarted);
    }
  }, [isApiRejected, isTimerStarted, tableTopDataFetcher]);

  const openModal = (index: number): void => {
    // audioTrigger.play({ name: 'menuClick' });
    const singleTopResult = tableTopData[index];
    openHashModel(
      index,
      'results',
      singleTopResult.multiplier,
      singleTopResult.hashKey,
      singleTopResult.encryptedResult,
      singleTopResult.gameEndTime?.split('.')[0].replace('T', ' ')
    );
  };

  return (
    <ScrollableWrapper>
      {((): ReactElement => {
        if (!tableTopData && isApiRejected) {
          return (
            <ErrorMessage
              title="HIGHFLYER_FAILED_TO_LOAD"
              message="HIGHFLYER_INTERNAL_ERROR"
              disabled={false}
              loading={false}
              onClick={(): void => {
                tableTopDataFetcher(TableTopTab.RESULTS, true);
                dispatch(highflyerGameStateActions.setErrorOccured());
              }}
            />
          );
        } else if (!tableTopData && !isApiRejected) {
          return <Loader />;
        } else {
          return (
            <div className={styles.tableTop_results_container}>
              {tableTopData &&
                tableTopData.map((item: TableTopInfo, index: number) => {
                  return (
                    <div className={styles.tableTop_single_results} key={`top-result-${id}`}>
                      <div>{getDateTime(item.gameEndTime)?.toString()}</div>
                      <div onClick={() => openModal(index)} className={styles.tableTop_results_multiplier}>
                        <SingleMultiplier value={Number(item?.multiplier)} />
                      </div>
                    </div>
                  );
                })}
            </div>
          );
        }
      })()}
    </ScrollableWrapper>
  );
};
